import { createAction, props } from '@ngrx/store';
import { AppUser } from 'src/app/services/auth.service';

// 🔹 Login con Google u otro proveedor
export const login = createAction('[Auth] Login');
export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: AppUser }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: any }>()
);

// 🔹 Logout
export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');
